import { css } from '@emotion/core';
import {
  FONT_WEIGHT_BOLD_PP,
  HIGH_CONTRAST_TEXT_COLOR,
  PAYPAL_OPEN_FONT,
  PRIMARY_COLOR_V2,
} from './styleVariables';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

const resetStyles = css`
  /* CSS reset */
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    border: 0;
    font: inherit;
    font-size: 100%;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  a {
    text-decoration: none;
  }

  body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    line-height: 1;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote::before,
  blockquote::after,
  q::before,
  q::after {
    content: '';
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  input,
  input[type='email'],
  input[type='button'],
  input[type='submit'],
  input[type='text'],
  input[type='tel'],
  button {
    appearance: none;
  }
`;

const globalStyles = css`
  /* PayPal global rules */
  body {
    color: ${HIGH_CONTRAST_TEXT_COLOR};
    font-family: ${PAYPAL_OPEN_FONT};
    margin: 0;

    .cart-header-sheet > div {
      /* stylelint-disable-next-line declaration-no-important */
      font-family: ${PAYPAL_OPEN_FONT} !important;
      /* stylelint-disable-next-line declaration-no-important */
      font-size: 18px !important;

      font-weight: 400;
    }

    .cart-header-dialog > div {
      /* stylelint-disable-next-line declaration-no-important */
      font-size: 20px !important;
    }
  }

  a {
    /* stylelint-disable-line no-duplicate-selectors */
    color: ${PRIMARY_COLOR_V2};
  }

  a,
  button {
    font-weight: ${FONT_WEIGHT_BOLD_PP};
  }

  input {
    border-style: none;
    color: ${HIGH_CONTRAST_TEXT_COLOR};
    min-width: 0;

    &:focus {
      border: 1px solid ${PRIMARY_COLOR_V2};
      outline: none;
    }
  }

  select {
    color: ${HIGH_CONTRAST_TEXT_COLOR};
  }

  /* stylelint-disable */

  /*
   * @TODO - DTOPPOR-656 fix CSP errors and remove global toast style overrides
  */
  .ppvx_toast-container___1-7-23-beta-0 {
    top: 1.5rem !important;
    z-index: 99999 !important;
  }

  /*
   * @TODO - DTOPPOR-656 fix CSP errors and remove global toast style overrides
  */
  .ppvx_toast___1-7-23-beta-0 {
    align-items: center !important;
    height: 4.125rem !important;
    max-width: 50rem !important;
    width: 35rem !important;

    @media (max-width: 48rem) {
      width: 93% !important;
    }
  }

  /*
   * Override caret placement for the Dialing Code Select Box.
  */
  .dialingCodeSelect::before {
    right: 10px !important;
  }
  /* stylelint-enable */
`;

export { globalStyles, resetStyles };
